// extracted by mini-css-extract-plugin
module.exports = {"route-loading":"route_route-loading__30d82","error-text":"route_error-text__dUXUB"};